import { useContext } from 'react';

import SummitCard from '@/components/game/ui/card/SummitCard';
import { GameContext, ViewContext } from '@/state/contexts';
import { logg } from '@/util/logg';
import { makeDecisionSummitDraftCardId } from '@lc/const/socketEvent';
import '@/style/HandModal.css';

const DecisionSummitDraftModal = () => {
	const { summitDraftCardIds, performAction }: any = useContext(GameContext); // currPlayer,
	const { toggleMinimize }: any = useContext(ViewContext);

	function makeChoice(e, cardId) {
		logg('makeChoiceSummitDraftId');
		logg(cardId);
		logg(summitDraftCardIds);
		e.preventDefault();

		performAction(makeDecisionSummitDraftCardId, { cardId });
	}

	return (
		<div className="modal">
			<div className="modal-content">
				<span className="close" onClick={toggleMinimize}>
					&minus;
				</span>
				<h2 className="modal-title">Your Choice of Summit Cards</h2>
				{summitDraftCardIds.length > 0 && (
					<div className="hand">
						{summitDraftCardIds.map((cardId) => (
							<div className="card">
								<SummitCard
									cardId={cardId}
									width={0}
									height={0}
								/>
								<button
									value={0}
									onClick={(e) => makeChoice(e, cardId)}
								>
									Play Card
								</button>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default DecisionSummitDraftModal;
